<template>
    <div>
        <common-content-spacer class="page-copy__center" height="large">
            <common-icon name="success" size="ultra-large"></common-icon>
            <common-page-header
                :heading="$t('modals.make_direct_referal_modal.invite_sent')"
                :isCenter="true"
            ></common-page-header>

            <p v-html="$t('modals.make_direct_referal_modal.invite_sent_to_email', { email: email.email })"></p>
            <svg style="width: 240px"><use xlink:href="#picture-email-sent" /></svg>

            <common-buttons>
                <common-button
                    type="primary"
                    size="large-long"
                    :label="$t('common.microcopy.close')"
                    @click="emitEvent({ name: 'close' })"
                ></common-button>
            </common-buttons>
        </common-content-spacer>
    </div>
</template>

<script>
    export default {
        props: { email: { type: Object, required: true } },
    }
</script>
